import { Routes } from '@angular/router';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const HUB_ROUTES: Routes = [
  {
    path: 'hub-theme',
    loadChildren: () =>
      import('./theme/theme.module').then((m) => m.HubThemeModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'hub-games',
    loadComponent: () =>
      import('./game/hub-game/game.component').then((m) => m.HubGameComponent),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
];
